import jQuery from 'jquery';
import Clipboard from 'clipboard';
import Swiper from 'swiper/bundle';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

window.$ = window.jQuery = jQuery;
window.Clipboard = Clipboard;
window.Swiper = Swiper;
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

gsap.registerPlugin(ScrollTrigger);